module.exports = __webpack_public_path__ + "img/temp_created_mind.ca6aa6a2.svg";